// extracted by mini-css-extract-plugin
module.exports = {"scrollTopButton":"scrollToTop_scrollTopButton__2q476","scrollTopButtonBlack":"scrollToTop_scrollTopButtonBlack__1kG8-","show":"scrollToTop_show__2CLad"};